<template>
  <carSearchVariant
    :disable="isExistingQuoteOpen || saving"
    :variants="variantDetails"
    :displayCard="displayCard"
    :saving="saving"
    :display-used-car-fields="displayUsedCarFields"
    :actions="actions"
    :odometer="customerOptions.odometer"
    :car-price="customerOptions.carPrice"
    :car-is-from-options="Object.values($Constants.CAR_IS_FROM_OPTIONS)"
    :car-is-from="customerOptions.carIsFrom"
    :errors="$v"
    @back="back"
    @update:display-card="updateDisplayedCard"
    @update:odometer="updateField('odometer', $event)"
    @update:price="updateField('carPrice', $event)"
    @update:car-is-from="updateField('carIsFrom', $event)"
    @select:car="selectCar"
  />
</template>

<script>
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';
import { getCardVariantDetails } from '@/utils/variant';
import validations from './validations';

export default {
  name: 'CarSearchVariantWidget',
  metaInfo: {
    title: 'Car Search Variant |'
  },
  data() {
    return {
      displayCard: 0,
      displayUsedCarFields: false,
      updateApplicationPaths:
        this.$Constants.APPLICATION_UPDATE_PATHS.carSearchVariant
    };
  },
  validations,
  computed: {
    ...mapState({
      quote: (state) => state.quote.quote,
      quoteSaving: (state) => state.quote.savingQuote,
      applicationSaving: (state) => state.application.applicationSaving,
      customerOptions: (state) =>
        state.application.application.metaData.customerOptions || {}
    }),
    ...mapGetters('carSearch', ['getVariants', 'isNew']),
    ...mapGetters('quote', ['isExistingQuoteOpen']),
    variantDetails() {
      return this.getVariants.map(getCardVariantDetails);
    },
    saving() {
      return this.quoteSaving || this.applicationSaving;
    },
    actions() {
      if (this.displayUsedCarFields) {
        return [
          {
            label: 'I’m done, get me a quote',
            action: this.selectCar,
            loading: this.saving
          }
        ];
      }

      const newActions = [
        {
          label: 'I have a copy of a quote',
          action: this.goToQuoteUpload
        },
        {
          label: 'Continue to accessories',
          loading: this.saving,
          action: this.selectCar
        }
      ];

      const usedActions = [
        {
          label: 'I have a price',
          action: this.goToQuoteUpload
        },
        {
          // eslint-disable-next-line
          label: 'I don\'t have a price',
          action: () => (this.displayUsedCarFields = true)
        }
      ];

      return this.isNew ? newActions : usedActions;
    }
  },
  methods: {
    ...mapMutations('application', ['updateCustomerOption']),
    ...mapActions('application', ['updateApplication']),
    ...mapActions('quote', ['createQuote']),
    back() {
      this.$router.push({
        name: this.$RouteNames.carSearch,
        params: { ...this.$router.currentRoute.params }
      });
    },
    resetVariantCardFields() {
      this.displayUsedCarFields = false;
      this.updateField('odometer', undefined);
      this.updateField('carPrice', undefined);
      this.updateField('carIsFrom', undefined);
      this.$v.$reset();
    },
    updateDisplayedCard(card) {
      this.resetVariantCardFields();
      this.displayCard = card;
    },
    goToQuoteUpload() {
      this.updateCustomerOption({
        field: 'variant',
        value: this.variantDetails[this.displayCard].id
      });
      this.$router.push({
        name: this.$RouteNames.quoteUpload,
        params: { ...this.$router.currentRoute.params }
      });
    },
    updateField(field, value) {
      this.updateCustomerOption({
        field,
        value
      });
    },
    async selectCar() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.updateCustomerOption({
        field: 'variant',
        value: this.variantDetails[this.displayCard].id
      });

      // Reset colour and extras fields
      this.updateCustomerOption({ field: 'exteriorColour', value: undefined });
      this.updateCustomerOption({ field: 'interiorColour', value: undefined });
      this.updateCustomerOption({ field: 'optionalEquipment', value: [] });
      this.updateCustomerOption({ field: 'adhocEquipment', value: [] });

      if (!this.isNew) {
        // Create quote also saves the application
        await this.createQuote({
          componentContext: this,
          updateApplicationPaths: this.updateApplicationPaths
        });
        return this.$router.push({
          name: this.$RouteNames.dealerPrice,
          params: {
            ...this.$router.currentRoute.params,
            quoteId: this.quote.quoteId
          }
        });
      } else {
        await this.updateApplication({
          updateApplicationPaths: this.updateApplicationPaths
        });
      }

      await this.$router.push({
        name: this.$RouteNames.carColourAndExtras,
        params: { ...this.$router.currentRoute.params }
      });
    }
  },
  mounted() {
    this.resetVariantCardFields();
  },
  components: {
    carSearchVariant: () => import('../../components/page/car-search-variant')
  }
};
</script>
